export default "__VITE_ASSET__B9hOHP2v__"